import React, { Component } from 'react';
import iconCantoneiras from '../../images/cantoneiras/icon_cantoneiras.png';

import './Cantoneiras.scss'

class Cantoneiras extends Component {

    render() {
        return (
            <section className="product-specifications">
                <div className="container">
                    <div className="box">
                        <h3>ESPECIFICAÇÕES</h3>
                        <div className="specification-list">
                            <div className="specification-list-item left">
                                <div className="icon-wrapper">
                                    <img src={iconCantoneiras} alt="" className="icon"/>
                                </div>
                                <div className="text">
                                    <p className="title">Cantoneiras laminadas</p>
                                    <p>Espessuras da <span>Cantoneira de aço Inox</span>: 1/8" a 5/8"</p>
                                    <p>Largura: 3/4" A "6</p>
                                    <p>Tipos de Aço: 304/ E 316/L</p>
                                </div>
                            </div>
                            <div className="specification-list-item left">
                                <div className="icon-wrapper">
                                    <img src={iconCantoneiras} alt="" className="icon"/>
                                </div>
                                <div className="text">
                                    <p className="title">Cantoneiras dobradas</p>
                                    <p>Dimensões da <span>Cantoneira de aço Inox</span>: Conforme solicitado pelo cliente.</p>
                                    <p>Comprimento: Máx. 6.100MM</p>
                                    <p>Tipos de Aço: 304/L, 310, 316/L, 410D, entre outros.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Cantoneiras;
